import * as yup from "yup";

const companySchema = yup.object({
  company_name: yup.string().nullable().default(""),
  company_identification: yup.string().nullable().default(""),
  company_identification2: yup.mixed().nullable().default(null),
  company_phone: yup.mixed().nullable().default(null),
  company_fax: yup.mixed().nullable().default(null),
  company_email: yup.mixed().nullable().default(null),
  company_position: yup.mixed().nullable().default(null)
});

const contactSchema = yup.object({
  phone: yup.string().required().default(""),
  phone2: yup.string().nullable().default(""),
  mobile: yup.string().required().default(""),
  fax: yup.string().nullable().default(""),
  email: yup.string().email().required().default("")
});

const locationSchema = yup.object({
  country: yup.string().nullable().default(""),
  city: yup.string().nullable().default(""),
  sector: yup.mixed().nullable().default(null),
  address: yup.string().required().default(""),
  reference: yup.string().required().default("")
});

export const ownerVerificationSchema = yup.object({
  id: yup.number().required().positive().integer(),
  name: yup.string().required().default(""),
  identification: yup.string().required().default(""),
  identification_type: yup.string().nullable().default(""),
  ...companySchema.fields,
  ...contactSchema.fields,
  ...locationSchema.fields,
  birthdate: yup.string().nullable().default(null),
  account_id: yup.number().required().positive().integer(),
  agency_id: yup.number().nullable().default(null),
  is_conflictive: yup.number().required().oneOf([0, 1]).default(0),
  conflictive_reason: yup.string().nullable().default("")
});

export const ownerVerificationResponseSchema = yup.object({
  data: yup.array().of(ownerVerificationSchema).required().default([]),
  status: yup.number().required().default(0),
  message: yup.string().required().default("")
});

export type OwnerVerificationData = yup.InferType<typeof ownerVerificationSchema>;
export type IOwnerVerificationResponse = yup.InferType<
  typeof ownerVerificationResponseSchema
>;
export const transformOwnerVerification = async (
  data: IOwnerVerificationResponse
) => {
  try {
    await ownerVerificationResponseSchema.isValid(data);
    return data;
  } catch (error) {
    console.log(error, "owner verification error");
    return {
      ...ownerVerificationResponseSchema.getDefault(),
      ...ownerVerificationResponseSchema.cast({ data: data, status: 0, message: "" })
    };
  }
};
